export class SureFlowLoopInitial {

  systemTypeCode!: string;
  coolingFluidTypeCode!: string;
  coolingGlycolPercentage!: number;
  coolingPipeId!: number;
  coolingFluidFlowRate!: number;
  heatingFluidTypeCode!: string;
  heatingGlycolPercentage!: number;
  heatingPipeId!: number;
  heatingFluidFlowRate!: number;
  description!: string;
  metric!: boolean;

}
